import styled from 'styled-components'

interface Props {
  children: JSX.Element | string
}

const InputError = styled.div`
  color: rgba(255, 11, 24, 0.67);
  font-size: 0.75em;
  margin-top: 5px;
`

export default function InputErrorMessage({ children }: Props): JSX.Element {
  return <InputError>{children}</InputError>
}
